export class OurStory {
  constructor() {
    console.log(' ::>> our story loaded ');
  }
}